import React from 'react';
import classNames from 'classnames';
import styles from './TextBadge.module.scss';
import { BadgeType } from '../Badge/Badge';

export type TextBadgeVariant = 'BETA';

export interface TextBadgeProps {
  text: TextBadgeVariant;
  type?: BadgeType | string;
  colorOverride?: string;
  transparent?: boolean;
  className?: string;
  onClick?: () => void;
  hoverText?: string;
}

export const TextBadge: React.FC<TextBadgeProps> = ({
  text,
  type = BadgeType.Neutral,
  colorOverride,
  transparent = false,
  className,
  onClick,
  hoverText,
}) => {
  const inlineStyles: React.CSSProperties = {};

  if (colorOverride) {
    inlineStyles.backgroundColor = colorOverride.startsWith('var(')
      ? `color-mix(in srgb, ${colorOverride} 14%, transparent)`
      : `${colorOverride}22`;
    inlineStyles.color = colorOverride;
  }

  const content = (
    <span
      title={hoverText}
      style={inlineStyles}
      className={classNames(
        styles.root,
        {
          [type]: !transparent,
        },
        className,
      )}>
      {text}{' '}
    </span>
  );

  return onClick ? (
    <button className={styles.button} onClick={onClick} type="button">
      {content}{' '}
    </button>
  ) : (
    content
  );
};
